// 导入导出模块
import VersionServices from '@/services/version.services'
const state = {
  nowurl: '',
  tableDateList: [], // 表格数据列表
  uploadVersionlist: [] // 版本包上传事件ID列表
}

const getters = {
  tableDateList (state) {
    return state.tableDateList
  },
  uploadVersionlist (state) {
    return state.uploadVersionlist
  },
  nowurl (state) {
    return state.nowurl
  }
}

const actions = {
}

const mutations = {
  // ------版本管理表格数据------
  // 删除表格数据
  DELETE_TABLETADE (state, data) {
    state.tableDateList = state.tableDateList.filter(
      item => item.deviceId !== data
    )
  },
  // 更新表格数据
  UPDATE_TABLETADE (state, data) {
    state.tableDateList = data
  },
  // 修改表格数据项进度
  CHECK_TABLETADE (state, data) {
    const { id, percent, isAbnormal, isComplete } = data
    const indexarr = []
    state.tableDateList.forEach((item, ind) => {
      if (item.url == state.nowurl) {
        indexarr.push(ind)
      }
    })
    if (indexarr.length <= 0) {
      return
    }
    indexarr.forEach(inditem => {
      state.tableDateList[inditem].percentage = percent
    })
  },

  // 版本管理-表格数据更新
  VERSIONMANAGE_TABLETADE (state) {
    if (state.uploadVersionlist.length <= 0) {
      return
    }
    console.log(state.tableDateList, 'state.tableDateList')
    console.log(state.uploadVersionlist, 'state.uploadVersionlist')
    state.tableDateList.forEach((tableitem, tableindex) => {
      state.uploadVersionlist.forEach((versionitem, versionindex) => {
        if (tableitem.url === versionitem.url && !versionitem.isAbnormal) {
          state.tableDateList[tableindex].percentage =
            state.uploadVersionlist[versionindex].percent
        }
      })
    })
  },
  // ------版本包上传事件ID列表数组操作---
  // 删除事件ID
  DELETE_VERSIONLIST (state, data) {
    state.uploadVersionlist = state.uploadVersionlist.filter(item => {
      return item.eventId !== data.id
    })
  },
  // 新增事件ID
  ADD_VERSIONLIST (state, data) {
    state.uploadVersionlist.push(data)
  },
  // 修改事件ID-获取修改项的URL,更新版本包上传事件ID列表
  EDIT_VERSIONLIST (state, data) {
    let urlitem = []
    let indexarr = []
    state.uploadVersionlist.forEach((item, ind) => {
      if (item.eventId == data.id) {
        indexarr.push(ind)
        urlitem[0] = item
      }
    })

    if (indexarr.length <= 0 || urlitem.length <= 0) {
      return
    }

    indexarr.forEach(item => {
      state.uploadVersionlist[item].percent = data.percent
      state.uploadVersionlist[item].isAbnormal = data.isAbnormal
      state.uploadVersionlist[item].isComplete = data.isComplete
    })

    state.nowurl = urlitem[0].url
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
